export default class ContentModel {
    constructor(
        public emailLabel: string,
        public emailPlaceholder: string,
        public buttonText: string,
        public succesMessageTitle: string,
        public succesMessage: string,
        public linkTargetPage: string,
        public linkText: string
    ) {

    }


}